export default class DomainUtils {
    static getDomain(hostname = window.location.hostname, port = window.location.port) {
        if (hostname === "localhost" || port === '3000')
            return "whitewhale.help";

        if (hostname === "")
            return "penis.news";

        const parts = hostname.split('.');

        if (parts.length >= 2) {
            return parts.slice(-2).join('.');
        }

        return hostname; 
    }
}
